import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxGlideModule } from 'ngx-glide';
import { MedicalFundraisingRoutingModule } from './medical-fundraising-routing.module';
import {
  MedicalLandingComponent, BannerComponent,
  MedicalCausesComponent, MedicalSEOComponent, CrowdfundingUseComponent,
  TestimonialsComponent, FaqsComponent, WhatKettoOffersComponent,
  ActiveFundraisersComponent, SacButtonComponent, NeedHelpComponent
} from './components';
import { LandingFooterComponent } from './components/landing-footer/landing-footer.component';
import { InViewportModule } from 'ng-in-viewport';
import {
  BannerNewComponent, TestimonialsNewComponent, CrowdfundingNewUseComponent,
  WhatKettoOffersNewComponent, MedicalCausesNewComponent, ActiveFundraisersNewComponent, FaqsNewComponent,
  HowItWorksMemComponent, CostCoverInfoComponent
} from './new-components';
import { ButtonModule } from '../common/button/button.module';
import { CommonTalktousModalModule } from '../common/common-talktous-modal/common-talktous-modal.module';
import { FreeBannerModule } from '../common/free-banner/free-banner.module';
import { FundraiserSIPBannerModule } from '../common/fundraiser-sipbanner/fundraiser-sipbanner.module';
import { StartfundraiserButtonModule } from '../common/startfundraiser-button/startfundraiser-button.module';
import { WidgetModule } from '../common/widget/widget.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';

@NgModule({
  declarations: [
    MedicalLandingComponent, BannerComponent,
    MedicalCausesComponent, MedicalSEOComponent, CrowdfundingUseComponent,
    TestimonialsComponent, FaqsComponent, WhatKettoOffersComponent,
    ActiveFundraisersComponent, SacButtonComponent, NeedHelpComponent, LandingFooterComponent,
    BannerNewComponent, MedicalCausesNewComponent, CrowdfundingNewUseComponent, WhatKettoOffersNewComponent,
    TestimonialsNewComponent, ActiveFundraisersNewComponent, FaqsNewComponent, HowItWorksMemComponent,
    CostCoverInfoComponent
  ],
  imports: [
    CommonModule,
    MedicalFundraisingRoutingModule,
    NgxGlideModule,
    WidgetModule,
    ButtonModule,
    CommonTalktousModalModule,
    FreeBannerModule,
    InViewportModule,
    StartfundraiserButtonModule,
    FundraiserSIPBannerModule,
    MatIconModule,
    MatButtonModule,
    MatExpansionModule,
    MatIconModule
  ]
})
export class MedicalFundraisingModule { }
